import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BasicThemeOneComponent } from './basic-theme-one/basic-theme-one.component';
import { BasicThemeThreeComponent } from './basic-theme-three/basic-theme-three.component';
import { BasicThemeTwoComponent } from './basic-theme-two/basic-theme-two.component';
import { BusinessThemeOneComponent } from './business-theme-one/business-theme-one.component';
import { BusinessThemeThreeComponent } from './business-theme-three/business-theme-three.component';
import { BusinessThemeTwoComponent } from './business-theme-two/business-theme-two.component';
import { CardCreatorComponent } from './card-creator/card-creator.component';
import { CardDetailsComponent } from './card-details/card-details.component';
import { CardsBydaterangeReportComponent } from './cards-bydaterange-report/cards-bydaterange-report.component';
import { CardsExpiryReportComponent } from './cards-expiry-report/cards-expiry-report.component';
import { DashAdminComponent } from './dash-admin/dash-admin.component';
import { DashAgentComponent } from './dash-agent/dash-agent.component';
import { DashEmployeeComponent } from './dash-employee/dash-employee.component';
import { ForBusinessComponent } from './for-business/for-business.component';
import { IndAgentCardsReportComponent } from './ind-agent-cards-report/ind-agent-cards-report.component';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { PaidCardsReportComponent } from './paid-cards-report/paid-cards-report.component';
import { PpComponent } from './pp/pp.component';
import { ProfThemeOneComponent } from './prof-theme-one/prof-theme-one.component';
import { ProfThemeThreeComponent } from './prof-theme-three/prof-theme-three.component';
import { ProfThemeTwoComponent } from './prof-theme-two/prof-theme-two.component';
import { SignupComponent } from './signup/signup.component';
import { TodayAgentsReportComponent } from './today-agents-report/today-agents-report.component';
import { TodayCardsReportComponent } from './today-cards-report/today-cards-report.component';
import { TosComponent } from './tos/tos.component';
import { TotalAgentssReportComponent } from './total-agentss-report/total-agentss-report.component';
import { TotalCardsReportComponent } from './total-cards-report/total-cards-report.component';
import { UnpaidCardsReportComponent } from './unpaid-cards-report/unpaid-cards-report.component';

const routes: Routes = [
  {
    path:'',
    component: MainComponent
  },
  {
    path:'index',
    component: MainComponent
  },
  {
    path:'login',
    component: LoginComponent
  },
  {
    path:'signup',
    component: SignupComponent
  },
  {
    path:'tos',
    component: TosComponent
  },
  {
    path:'pp',
    component: PpComponent
  },
  {
    path:'beingagent',
    component: ForBusinessComponent
  },
  {
    path:'card-creator',
    component: CardCreatorComponent
  },
  {
    path:'admin',
    component: DashAdminComponent
  },
  {
    path:'employee',
    component: DashEmployeeComponent
  },
  {
    path:'agent',
    component: DashAgentComponent
  },
  {
    path:'card-details',
    component: CardDetailsComponent
  },
  {
    path:'b1',
    component: BasicThemeOneComponent
  },
  {
    path:'b2',
    component: BasicThemeTwoComponent
  },
  {
    path:'b3',
    component: BasicThemeThreeComponent
  },
  {
    path:'bs1',
    component: BusinessThemeOneComponent
  },
  {
    path:'bs2',
    component: BusinessThemeTwoComponent
  },
  {
    path:'bs3',
    component: BusinessThemeThreeComponent
  },
  {
    path:'pr1',
    component: ProfThemeOneComponent
  },
  {
    path:'pr2',
    component: ProfThemeTwoComponent
  },
  {
    path:'pr3',
    component: ProfThemeThreeComponent
  },
  {
    path:'today-cards',
    component: TodayCardsReportComponent
  },
  {
    path:'today-agents',
    component: TodayAgentsReportComponent
  },
  {
    path:'total-cards',
    component: TotalCardsReportComponent
  },
  {
    path:'total-agents',
    component: TotalAgentssReportComponent
  },
  {
    path:'cards-by-daterange',
    component: CardsBydaterangeReportComponent
  },
  {
    path:'paid-cards',
    component: PaidCardsReportComponent
  },
  {
    path:'unpaid-cards',
    component: UnpaidCardsReportComponent
  },
  {
    path:'cards-expiry-tomorrow',
    component: CardsExpiryReportComponent
  },
  {
    path:'cards-reffered',
    component: IndAgentCardsReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
